import { Injectable } from "@angular/core";
import { Manual } from "../models/manual/manual";
import { ArticleListAdapter } from "./article-list.adapter";
import { Adapter } from "@core/adapter";

@Injectable({providedIn: 'root'})
export class ManualAdapter implements Adapter<Manual> {
  constructor(private articleListAdapter:ArticleListAdapter){}
  adapt(item: any): Manual {
    return {
      id: item.id,
      name: item.title,
      slug: item.slug,
      language: item.language.replace('/languages/', ''),
      updatedAt : item.updatedAt,
      status: item.visible,
      groups: item.personGroups.map((g: any) => g.id),
      articles: item.topLevelArticles.map((x:any) => this.articleListAdapter.adaptFromManualArticle(x)),
      automaticNumbers:item.automaticNumbers??false
    };
  }
}
